// extracted by mini-css-extract-plugin
export default {"chatLinkButton":"CandidateHeader_chatLinkButton__W4Sz0"};